module.exports = __webpack_public_path__ + "img/Julius.4475d7ad.svg";